import { Deserializable } from '../../protocols/deserializable';

export class ChangeEmailRequest implements Deserializable {
  public currentEmail: string = '';
  public newEmail: string = '';
  onDeserialize = () => {};
}
